import React, { useState, useEffect } from "react";
import Popup from "../Popup";
import FormHeader from "../form/Header";
import { useTranslation } from "react-i18next";
import { CentsToDollars } from "../../utils/formatPrice";
import { formatDate } from "../../utils/formatDate";
import { GetCombineOrder } from "../../api/sell-orders/getCombineOrder";

const ViewCombineOrder = ({ order, onClose, ...props }) => {
  const { t } = useTranslation();
  const [fullOrder, setFullOrder] = useState("");
  const [loading, setLoading] = useState(false);

  const getFullOrder = async () => {
    if (order.id) {
      setLoading(true);
      try {
        const { data } = await GetCombineOrder({ id: order.id });
        setFullOrder(data);
      } catch (err) {
        console.log("Full order couldn't be fetched. " + err.message);
      }
      setLoading(false);
    }
  };

  useEffect(() => {
    getFullOrder();
    // eslint-disable-next-line
  }, []);

  return (
    <Popup size="large" withClose withOverlay onClose={onClose}>
      <FormHeader title={`${t("Combine Order ID")}: ${order.id}`}></FormHeader>

      <div className="mt-5">
        <p>
          {t("Order number")}: <strong>{order.id}</strong>
        </p>
        <p>
          {t("Order date")}: <strong>{formatDate(order.created_at)}</strong>
        </p>
        <p>
          {t("Type")}: <strong>{order.type.toUpperCase()}</strong>
        </p>
        <p>
          {t("Status")}:{" "}
          <strong className="text-uppercase">{order.status}</strong>
        </p>
        <p>
          {t("User")}: <strong>{order.created_by_name}</strong>
        </p>
        <p>
          {t("Total Combined Amount")}:{" "}
          <strong>{CentsToDollars(order.total_source_amount || 0)}</strong>
        </p>
        <p>
          {t("Client Company Name")}:{" "}
          <strong>{order.client_company_name}</strong>
        </p>
        <p>
          {t("Office Name")}: <strong>{order.office_name}</strong>
        </p>
        <p>
          {t("Transaction ID")}: <strong>{order.transaction_id}</strong>
        </p>
        {loading && t("Loading additional data...")}
        {!loading && fullOrder && fullOrder.cards && (
          <>
            <div className="mb-3">
              <h5 className="mb-1 mt-2">
                {t("Source Card Details")}:
              </h5>
              <table>
                <thead>
                  <tr>
                    <th>{t("Proxy number")}</th>
                    <th>{t("Amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {fullOrder.cards
                    .filter((c) => c.type === "unload")
                    .map((card, index) => (
                      <tr key={index}>
                        <td>{card.processor_reference}</td>
                        <td>
                          {CentsToDollars(card.load_amount || 0)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
              <h5 className="mb-1 mt-2">
                {t("Destination Card Details")}:
              </h5>
              <table>
                <thead>
                  <tr>
                    <th>{t("Proxy number")}</th>
                    <th>{t("Amount")}</th>
                  </tr>
                </thead>
                <tbody>
                  {fullOrder.cards
                    .filter((c) => c.type === "load")
                    .map((card, index) => (
                      <tr key={index}>
                        <td>{card.processor_reference}</td>
                        <td>
                          {CentsToDollars(card.load_amount || 0)}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </Popup>
  );
};

export default ViewCombineOrder;
